
export default {
  items: [ ]
};
